import { ModuleWithProviders, NgModule } from '@angular/core';
import { MonitoringInitializerService, MemoryTracker, PerformanceInfoProvider, MonitoringService } from './services';
import { DataDogConfiguration } from './models';

@NgModule({})
export class MonitoringModule {
  private static isInitializationPending? = true;

  constructor(monitoringInitializerService: MonitoringInitializerService) {
    if (MonitoringModule.isInitializationPending) {
      monitoringInitializerService.initAsync();
      delete MonitoringModule.isInitializationPending; // so we don't keep unnecessary values in memory
    }
  }

  static withConfig(dataDogConfig: DataDogConfiguration): ModuleWithProviders<MonitoringModule> {
    return {
      ngModule: MonitoringModule,
      providers: [
        MonitoringInitializerService,
        MemoryTracker,
        PerformanceInfoProvider,
        MonitoringService,
        { provide: 'dd-config', useValue: dataDogConfig }
      ]
    };
  }
}
